import { fromJS } from 'immutable';

import companyRecord from 'records/company';
import baseReducer from 'redux/baseReducer';
import { types as companyTypes } from 'redux/company/reducer';
import { POST_SUBSCRIPTION_CARD_SUCCESS, PUT_SUBSCRIPTION_SUCCESS } from 'redux/subscription/reducer';
import { createSymbols } from 'utils/helpers';
import { mapMe } from 'utils/mapToRecord';

const initialState = fromJS({
    data: mapMe({}),
    hasFetched: false,
    hasSignedUp: false,
    isFetching: false,
    isPurchasingBoost: false,
    jwt: '',
    showBoostModal: false,
});

export const {
    EDIT_IN_ME,
    FETCH_ME,
    FETCH_ME_FAIL,
    FETCH_ME_SUCCESS,
    PATCH_COMPANY,
    PATCH_COMPANY_FAIL,
    PATCH_COMPANY_SUCCESS,
    PATCH_ME,
    PATCH_ME_FAIL,
    PATCH_ME_SUCCESS,
    PURCHASE_BOOSTS,
    PURCHASE_BOOSTS_FAIL,
    PURCHASE_BOOSTS_SUCCESS,
    SIGN_ME_UP,
    SIGN_ME_UP_FAIL,
    SIGN_ME_UP_SUCCESS,
} = createSymbols([
    'EDIT_IN_ME',
    'FETCH_ME',
    'FETCH_ME_FAIL',
    'FETCH_ME_SUCCESS',
    'PATCH_COMPANY',
    'PATCH_COMPANY_FAIL',
    'PATCH_COMPANY_SUCCESS',
    'PATCH_ME',
    'PATCH_ME_FAIL',
    'PATCH_ME_SUCCESS',
    'PURCHASE_BOOSTS',
    'PURCHASE_BOOSTS_FAIL',
    'PURCHASE_BOOSTS_SUCCESS',
    'SIGN_ME_UP',
    'SIGN_ME_UP_FAIL',
    'SIGN_ME_UP_SUCCESS',
]);

const editInMe = (state, action) => state.setIn(action.path, action.value);
const fetchMe = (state) => state.set('isFetching', true);
const fetchMeFail = (state) => state.set('isFetching', false).set('hasFetched', true);
const fetchMeSuccess = (state, action) => state.withMutations((prevState) => {
    prevState.set('isFetching', false)
        .set('hasFetched', true)
        .set('data', mapMe(action.payload.data));
});
const patchCompanySuccess = (state, action) => {
    return state.setIn(['data', 'company'], companyRecord(fromJS(action.payload.data)));
};
const patchMeSuccess = (state, action) => {
    return state.set('data', mapMe(action.payload.data));
};
const purchaseBoostStart = (state) => state.set('isPurchasingBoost', true);
const purchaseBoostFinish = (state) => state.set('isPurchasingBoost', false);
const purchaseBoostSuccess = (state) => {
    const updatedState = purchaseBoostFinish(state);
    const remainingBoosts = state.getIn(['data', 'company', 'remainingBoosts']);

    return updatedState.setIn(['data', 'company', 'remainingBoosts'], remainingBoosts + 1);
};
const putSubscriptionSuccess = (state, action) => {
    const data = fromJS(action.payload.data);
    const user = data.getIn(['company', 'users', 0]);
    const company = user.set('activeSubscription', fromJS(data));

    return state.setIn(['data', 'company'], companyRecord(company));
};
const signMeUpSuccess = (state) => state.set('hasSignedUp', true);

export default baseReducer(initialState, {
    [companyTypes.PATCH_SUCCESS]: patchCompanySuccess,
    [EDIT_IN_ME]: editInMe,
    [FETCH_ME]: fetchMe,
    [FETCH_ME_FAIL]: fetchMeFail,
    [FETCH_ME_SUCCESS]: fetchMeSuccess,
    [PATCH_COMPANY_SUCCESS]: patchCompanySuccess,
    [PATCH_ME_SUCCESS]: patchMeSuccess,
    [POST_SUBSCRIPTION_CARD_SUCCESS]: patchCompanySuccess,
    [PURCHASE_BOOSTS]: purchaseBoostStart,
    [PURCHASE_BOOSTS_FAIL]: purchaseBoostFinish,
    [PURCHASE_BOOSTS_SUCCESS]: purchaseBoostSuccess,
    [PUT_SUBSCRIPTION_SUCCESS]: putSubscriptionSuccess,
    [SIGN_ME_UP_SUCCESS]: signMeUpSuccess,
});
